import React, { useEffect, Suspense } from 'react';
import { PropTypes } from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearState } from 'aurora-composition/modules/lease/actions';

import Loading from 'aurora-components/Loading';
import Dashboard from '../Templates/Dashboard';

import {
  Error,
  NotFound,
  DashboardHome,
  Applications,
  ApplicationDetail,
  Contracts,
  LeaseContractDetail,
  PmaContractDetail,
  OffPlanContractDetail,
  MortgageContractDetail,
  POAContractDetail,
  Services,
  Properties,
  PropertyDetail,
  // Directory
  Directory,
  DirectoryProject,
  DirectoryProfession,
  DirectoryProfessionEmployee,
  UserProfile,
  // tenant Application
  TenantReview,
  TenantReject,
  TenantApproval,
  TenantRejectClosure,
  TenantRejectCancel,

  // owner Application
  OwnerReview,
  OwnerTermination,
  OwnerApprovalClosureReject,
  // lease CLOSURE
  LeaseClosure,
  LeaseClosureSucess,
  // lease Canecllation
  LeaseCancellation,
  LeaseCancellationSucess,
  TenantRejectCancellation,
  TenantApprovalCancellation,
  TenantApprovalClosure,
  // lease termination court order
  LeaseTerminationCourt,
  LeaseTerminationCourtSucess,
  // lease payment
  LeasePayment,
  LeasePaymentSuccess,
  LeasePaymentSuccessTenant,
  LeaseFinalSuccess,
  // Byuer & other seller review
  BuyerSellerReview,
  OtherSellerApproval,
  OtherSellerRejection,
  SellPurchaseOwner,
  SellPurchaseOwnerSuccess,
  SellPurchaseDMTBooking,
  SellPurchasePayment,
  SalePurchasePaymentSuccess,
  SellerTermination,
  // Register Company Account
  RegisterCompanyApplicationDetails,
  RegisterCompanyReturnFlows,
  // Add Company Employee
  AddCompanyEmployeeApplicationDetails,
  AddCompanyEmployeeApprovalPage,
  AddCompanyEmployeeReturnedPage,

  // PMA
  PmaOwnerReview,
  PmaOwnerReviewSuccess,
  PmaOwnerReviewTermination,
  PmaCompanyReview,
  PmaPostApprovals,
  PmaPayments,
  PmaReviewApproval,
  PmaReviewRejection,
  PmaReviewReturned,
  PmaContractDownload,
  // PMAContractTermination,
  PMAContractTerminationSubmission,
  BrokerReview,
  BrokerOwnerAccept,
  BrokerOwnerReject,
  BrokerPayment,
  BrokerAcceptBroker,
  BrokerRejectBroker,
  BrokerCancelBroker,
  AppointmentBooking,
  BuyerReviews,
  AboutUs,
  MarketDataMobile,
  Authorization,
  SaleService,
  LeaseService,
  CertificateService,
  CompanyService,
  DirectoryService,
  // TermsCondition,
  PrivacyPolicy,
  ContactUs,
  VerifyTenantContract,
  PropertyListing,
  PMAContractPropertyListing,
  MarketData,
  MusatahaTenantReview,
  MusatahaOwnerReview,
  PmaPayment,
  // Waiver Musataha
  MusatahaWaiverOwnerReview,
  MusatahaWaiverBuyerReview,
  WaiverBuyerReturnSuccess,
  WaiverBuyerApprovalSuccess,
  WaiverOwnerTerminationSuccess,
  WaiverPayment,
  WaiverPaymentSuccess,
  WaiverApplicationDetail,
  MusatahaPayment,
  MusatahaPaymentSuccess,
  MusatahaApplicationDetail,
  WaiverBuyerRejectionSuccess,
  WaiverMusatahaDownload,
  MusatahaDownload,

  // offPlanBuySell
  OffPlanBuySellApplicationDetails,
  OffPlanBuySellApprovalFlow,
  OffPlanBuySellReturnFlow,
  OffplanBuySellPayments,

  // mortgage
  MortgageApplicationDetail,
  MortgagePostApprovals,
  MortgagePostReturn,
  MortgagePayment,

  // Transfer offplan
  TransferOffplanApplicationDetail,
  TransferOffplanPostApprovals,
  TransferOffplanPayment,
  TransferOffplanPostReturn,
  MusatahaContractDetail,

  // NHl mortgage
  NhlMortgageApplicationDetail,
  NhlMortgagePostApprovals,
  NhlMortgagePostReturn,
  NhlMortgagePayment,

  // Rent Payment
  RentPaymentApplicationDetails,
  RentPaymentApprovalFlow,
  RentPaymentReturnFlow,
  RentPaymentPaymentFlow,

  // off plan termination
  OffPlanTerminationApplicationDetails,
  OffPlanTerminationPaymentFlow,
  OffPlanTerminationApprovals,
  OffPlanTerminationReturn,
  OffPlanTerminationBankFlow,

  // off plan project registration
  OffPlanProjectRegistrationApplicationDetails,
  OffPlanProjectRegistrationApprovals,
  OffPlanProjectRegistrationReturn,
  OffPlanProjectRegistrationPayment,

  // Project List
  ProjectList,

  // Developer Project
  DeveloperProjectDetail,
  DeveloperProjectList,

  // DRC - Register Dispute
  registerDisputeApplicationDetails,
  registerDisputeApprovalsPage,
  registerDisputeReturnedPage,

  // DRC - Request for expert opinion
  RequestForExpertOpinionApprovalsPage,
  RequestForExpertOpinionApplicationDetails,
  RequestForExpertOpinionPayment,

  // new static
  ADGMOffices,
  ADGMAtyourPlace,

  // DRC - execution Stamp
  ExecutionStampPaymentFlow,
  ExecutionStampApplicationDetails,
  ADGMelifeService,
  ADGMelifeServiceSuccess,
  // Escrow Account
  EscrowAccountApplicationDetail,
  EscrowAccountApplicationPayment,
  EscrowAccountApplicationDetailFinal,

  // Escrow Account
  ServiceProviderApprovalApplicationDetailFinal,
  ServiceProviderApprovalApplicationDetail,
  ServiceProviderApprovalReturnApplicationDetail,

  // Update company
  UpdateCompanyDetail,
  UpdateCompanyReturn,
  ProfessionRegistrationPaymentFlow,
  ProfessionRegistrationApplicationDetails,
  ProfessionRegistrationReturnFlow,

  // Mortgage Release
  MortgageReleaseApplicationDetails,
  MortgageReleaseApplicationPayment,
  MortgageReleaseApplicationApproval,
  MortgageReleaseApplicationReturn,
  PermitsApplicationDetails,

  // certificates
  ValuationCertificateApplicationDetails,
  ValuationCertificateReturnFlow,
  MusatahaContractRegistrationApprovalFlow,
  MusatahaContractRegistrationAppDetail,
  MusatahaContractPayemnt,
  MusatahaContractRegReturn,

  // Register POA
  RegisterPOAApplicationDetails,
  TerminatePOAApplicationDetails,
  RegisterPOAApplicationReturn,

  // Sell & Purchase
  SellAndPurchaseApplicationDetails,
  SellAndPurchaseApprovalFlow,
  SellAndPurchaseReturnFlow,
  SellAndPurchasePaymentFLow,
  // Transfer of Interest
  TransferOfInterestApplicationDetails,
  TransferOfInterestApprovalFlow,
  TransferOfInterestReturnFlow,
  TransferOfInterestPaymentFLow,

  // Transfer of Interest
  DigitalTransferOfInterestApplicationDetails,
  DigitalTransferOfInterestApprovalFlow,
  DigitalTransferOfInterestReturnFlow,
  DigitalTransferOfInterestPaymentFLow,

  // Manual Profile Creation
  ManualProfileCreationReturnFlow,
  ManualProfileCreationApplicationDetails,
  // Instant Services
  InstantServiceApplicationDetails,
  InstantServicePaymentFlow,
  // Certificates
  CertificatesApplicationDetails,
  CertificatesPaymentFlow,

  // Mortgage Modification
  MortgageModificationApplicationDetail,
  MortgageModificationReturnFlow,
  MortgageModificationApprovalFlow,
  MortgageModificationPaymentFlow,

  // Legal Notice
  LegalNoticeReturnFlow,
  LegalNoticeApprovalFlow,
  LegalNoticeApplicationDetails,

  // Madhmoun
  RequestPermitAdvertisementPayment,
  RequestPermitAdvertisementDetails,
  RequestPermitAdvertisementApprovalFlow,
  RequestPermitAdvertisementReturnFlow,
  // Feedback form .
  FeedBackForm,
} from '../auroraPageLoader';

function Application(props) {
  const {
    history,
    location: { pathname },
  } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    localStorage.removeItem('onCertificatePropertySelection');
    localStorage.removeItem('onLeaseContractSelection');
    localStorage.removeItem('onSalePropertySelection');
    window.scrollTo(0, 0);
    if (!pathname.includes('/app/user/profile')) {
      localStorage.removeItem('isMobile');
      localStorage.removeItem('backUrl');
      localStorage.removeItem('isMobile');
      localStorage.removeItem('titleMobile');
      localStorage.removeItem('screen');
    }
    if (!pathname.includes('/app/services/')) {
      localStorage.removeItem('localStorageApplicationId');
      dispatch(clearState());
    }
    if (!pathname.includes('/login') && localStorage.getItem('uae_pass_errorCode_count') === '2') {
      localStorage.removeItem('uae_pass_errorCode_count');
      localStorage.removeItem('uae_pass_errorCode');
    }
  }, [pathname]);
  return (
    <Dashboard history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route exact path='/app/market-data-detail' component={MarketData} />
          <Route exact path='/app/about-us' component={AboutUs} />
          <Route exact path='/app/market-data-mobile' component={MarketDataMobile} />
          <Route exact path='/app/authorization-service' component={Authorization} />
          <Route exact path='/app/lease-service' component={LeaseService} />
          <Route exact path='/app/dircetory-service' component={DirectoryService} />
          <Route exact path='/app/sale-service' component={SaleService} />
          <Route exact path='/app/certificate-service' component={CertificateService} />
          <Route exact path='/app/company-service' component={CompanyService} />
          <Route exact path='/app/contact-us' component={ContactUs} />
          <Route exact path='/app/adgm-offices' component={ADGMOffices} />
          <Route exact path='/app/elife-service' component={ADGMelifeService} />
          <Route exact path='/app/elife-service-success' component={ADGMelifeServiceSuccess} />
          <Route exact path='/app/adgm-at-your-place' component={ADGMAtyourPlace} />
          {/* <Route exact path='/app/term-and-condition' component={TermsCondition} /> */}
          <Route exact path='/app/privacy-policy' component={PrivacyPolicy} />
          <Route exact path='/app/home' component={DashboardHome} />
          <Route exact path='/app/feedback' component={FeedBackForm} />
          <Route exact path='/app/contracts' component={Contracts} />
          <Route exact path='/app/contract/lease/:contractId' component={LeaseContractDetail} />
          <Route exact path='/app/contract/pma/:contractId' component={PmaContractDetail} />
          <Route exact path='/app/contract/offplan/:contractId' component={OffPlanContractDetail} />
          <Route exact path='/app/contract/musataha/:contractSource/:contractId' component={MusatahaContractDetail} />
          <Route exact path='/app/contract/mortgage/:contractId' component={MortgageContractDetail} />
          <Route exact path='/app/contract/poa/:contractId' component={POAContractDetail} />
          <Route exact path='/app/applications' component={Applications} />
          <Route exact path='/app/application/:type/:id' component={ApplicationDetail} />
          {/* Lease Application */}
          <Route exact path='/app/applications/lease/lessee-review' component={TenantReview} />
          <Route exact path='/app/applications/lease/tenant-reject' component={TenantReject} />
          <Route exact path='/app/applications/lease/expiration-reject' component={TenantRejectClosure} />
          <Route exact path='/app/applications/lease/surrender-reject' component={TenantRejectCancel} />
          <Route exact path='/app/applications/lease/lessee-approval' component={TenantApproval} />
          <Route exact path='/app/applications/lease/owner-approval' component={TenantApproval} />
          <Route exact path='/app/applications/lease/owner-review' component={OwnerReview} />
          <Route exact path='/app/applications/lease/owner-termination' component={OwnerTermination} />
          <Route exact path='/app/applications/lease-payment/:id' component={LeasePayment} />
          <Route exact path='/app/applications/lease-payment-success' component={LeasePaymentSuccess} />
          <Route exact path='/app/applications/lease-tenant-payment-success' component={LeasePaymentSuccessTenant} />
          <Route exact path='/app/services/lease-expiration' component={LeaseClosure} />
          <Route exact path='/app/services/lease-expiration-success' component={LeaseClosureSucess} />
          <Route exact path='/app/services/lease-surrender' component={LeaseCancellation} />
          <Route exact path='/app/services/lease-surrender-success' component={LeaseCancellationSucess} />
          <Route exact path='/app/applications/lease-surrender/tenant-reject' component={TenantRejectCancellation} />
          <Route
            exact
            path='/app/applications/lease-surrender/tenant-approval'
            component={TenantApprovalCancellation}
          />
          <Route exact path='/app/applications/lease-surrender/owner-approval' component={TenantApprovalCancellation} />
          <Route exact path='/app/applications/lease-expiration/tenant-approval' component={TenantApprovalClosure} />
          <Route exact path='/app/applications/lease-expiration/owner-approval' component={TenantApprovalClosure} />
          <Route exact path='/app/applications/lease/approval/reject-success' component={OwnerApprovalClosureReject} />
          <Route exact path='/app/applications/lease-final-success' component={LeaseFinalSuccess} />
          <Route exact path='/app/services/lease-termination-court-order' component={LeaseTerminationCourt} />
          <Route
            exact
            path='/app/services/lease-termination-court-order-success'
            component={LeaseTerminationCourtSucess}
          />
          {/* Sell Purchase Application */}
          <Route exact path='/app/applications/sell-purchase/buyer-review' component={BuyerSellerReview} />
          <Route exact path='/app/applications/sell-purchase/seller-review' component={BuyerSellerReview} />
          <Route exact path='/app/applications/sell-purchase/seller-approval' component={OtherSellerApproval} />
          <Route exact path='/app/applications/sell-purchase/buyer-approval' component={OtherSellerApproval} />
          <Route exact path='/app/applications/sell-purchase/seller-return' component={OtherSellerRejection} />
          <Route exact path='/app/applications/sell-purchase/buyer-return' component={OtherSellerRejection} />
          <Route exact path='/app/applications/sell-purchase/owner-review' component={SellPurchaseOwner} />
          <Route exact path='/app/applications/sell-purchase/owner-success' component={SellPurchaseOwnerSuccess} />
          <Route exact path='/app/applications/sell-purchase/appointment-booking' component={SellPurchaseDMTBooking} />
          <Route exact path='/app/applications/sell-purchase-payment' component={SellPurchasePayment} />
          <Route exact path='/app/applications/sell-purchase-payment-success' component={SalePurchasePaymentSuccess} />
          <Route exact path='/app/applications/sell-purchase/seller-termination' component={SellerTermination} />
          {/* Register Company Account Application */}
          <Route
            exact
            path='/app/application/detail/register-company-account/:id'
            component={RegisterCompanyApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/register-company-account/post-returns/:id'
            component={RegisterCompanyReturnFlows}
          />
          {/* Company Application */}
          <Route
            exact
            path='/app/application/detail/add-employee/:id'
            component={AddCompanyEmployeeApplicationDetails}
          />
          <Route
            exact
            path='/app/application/add-employee/post-approvals/:id'
            component={AddCompanyEmployeeApprovalPage}
          />
          <Route
            exact
            path='/app/application/add-employee/post-returns/:id'
            component={AddCompanyEmployeeReturnedPage}
          />
          {/* Update company */}
          <Route exact path='/app/application/detail/update-company/:id' component={UpdateCompanyDetail} />
          <Route exact path='/app/application/update-company/return/:id' component={UpdateCompanyReturn} />
          {/* Broker Application */}
          <Route exact path='/app/applications/broker/broker-review' component={BrokerReview} />
          <Route exact path='/app/applications/broker/owner-accept' component={BrokerOwnerAccept} />
          <Route exact path='/app/applications/broker/owner-reject' component={BrokerOwnerReject} />
          <Route exact path='/app/applications/broker-payment' component={BrokerPayment} />
          <Route exact path='/app/applications/broker/broker-accept' component={BrokerAcceptBroker} />
          <Route exact path='/app/applications/broker/broker-reject' component={BrokerRejectBroker} />
          <Route exact path='/app/applications/broker/broker-cancel' component={BrokerCancelBroker} />
          {/* PMA Application */},
          <Route exact path='/app/applications/pma/owner-review' component={PmaOwnerReview} />
          <Route exact path='/app/applications/pma/owner-success' component={PmaOwnerReviewSuccess} />
          <Route exact path='/app/applications/pma/owner-termination' component={PmaOwnerReviewTermination} />
          <Route exact path='/app/applications/pma/party-review' component={PmaCompanyReview} />
          {/* new routes */}
          <Route exact path='/app/applications/pma/post-approvals/:id' component={PmaPostApprovals} />
          <Route exact path='/app/applications/pma/payment/:id' component={PmaPayments} />
          {/* new routes */}
          <Route exact path='/app/applications/pma/other-owner-review' component={PmaCompanyReview} />
          <Route exact path='/app/applications/appointment-booking-success' component={AppointmentBooking} />
          <Route exact path='/app/applications/propert-offplan/buyer-review' component={BuyerReviews} />
          <Route exact path='/app/properties' component={Properties} />
          <Route exact path='/app/properties/:id' component={PropertyDetail} />
          <Route exact path='/app/applications/pma/properties/:id' component={PropertyListing} />
          <Route exact path='/app/contract/pma/properties/:id' component={PMAContractPropertyListing} />
          <Route exact path='/app/applications/pma/party-approval' component={PmaReviewApproval} />
          <Route exact path='/app/applications/pma/party-returned' component={PmaReviewReturned} />
          <Route exact path='/app/applications/pma/party-reject' component={PmaReviewRejection} />
          <Route exact path='/app/services/pma-contract-success' component={PmaContractDownload} />
          {/* <Route exact path='/app/services/pma-cancellation' component={PMAContractTermination} /> */}
          <Route
            exact
            path='/app/applications/pma-cancellation-submission'
            component={PMAContractTerminationSubmission}
          />
          <Route exact path='/app/applications/pma-payment' component={PmaPayment} />
          {/* Directory */}
          <Route exact path='/app/directory' component={Directory} />
          <Route exact path='/app/directory/project/:id' component={DirectoryProject} />
          <Route exact path='/app/directory/profession' component={DirectoryProfession} />
          <Route exact path='/app/directory/profession/:name' component={DirectoryProfessionEmployee} />
          <Route path='/app/services' component={Services} />
          <Route path='/app/user' component={UserProfile} />
          <Route path='/app/pages/not-found' component={NotFound} />
          <Route path='/app/pages/error' component={Error} />
          <Route path='/app/verify-documents' component={VerifyTenantContract} />
          {/* Long Lease to Musataha */}
          <Route exact path='/app/applications/musataha/tenant-review' component={MusatahaTenantReview} />
          <Route exact path='/app/applications/musataha/owner-review' component={MusatahaOwnerReview} />
          <Route exact path='/app/applications/musataha/payment/:id' component={MusatahaPayment} />
          <Route exact path='/app/applications/musataha/payment-success' component={MusatahaPaymentSuccess} />
          <Route exact path='/app/application/detail/musataha/:id' component={MusatahaApplicationDetail} />
          {/* Waiver Musatah Application */}
          <Route
            exact
            path='/app/applications/waiver-musataha/owner-review/:id'
            component={MusatahaWaiverOwnerReview}
          />
          <Route
            exact
            path='/app/applications/waiver-musataha/buyer-review/:id'
            component={MusatahaWaiverBuyerReview}
          />
          <Route
            exact
            path='/app/applications/waiver-musataha/seller-review/:id'
            component={MusatahaWaiverBuyerReview}
          />
          <Route exact path='/app/applications/waiver-musataha/buyer-return' component={WaiverBuyerReturnSuccess} />
          <Route exact path='/app/applications/waiver-musataha/buyer-approval' component={WaiverBuyerApprovalSuccess} />
          <Route exact path='/app/applications/waiver-musataha/seller-return' component={WaiverBuyerReturnSuccess} />
          <Route exact path='/app/applications/waiver-musataha/seller-reject' component={WaiverBuyerRejectionSuccess} />
          <Route
            exact
            path='/app/applications/waiver-musataha/seller-approval'
            component={WaiverBuyerApprovalSuccess}
          />
          <Route exact path='/app/applications/waiver-musataha/payment/:id' component={WaiverPayment} />
          <Route exact path='/app/applications/waiver-musataha/payment-success' component={WaiverPaymentSuccess} />
          <Route exact path='/app/application/detail/waiver-musataha/:id' component={WaiverApplicationDetail} />
          <Route exact path='/app/applications/waiver-musataha/buyer-reject' component={WaiverBuyerRejectionSuccess} />
          <Route
            exact
            path='/app/applications/waiver-musataha/owner-termination'
            component={WaiverOwnerTerminationSuccess}
          />
          <Route exact path='/app/applications/waiver-musataha/final-success/:id' component={WaiverMusatahaDownload} />
          <Route exact path='/app/applications/musataha/final-success/:id' component={MusatahaDownload} />
          {/* Mortgage routes */}
          <Route exact path='/app/application/detail/mortgage/:id' component={MortgageApplicationDetail} />
          <Route exact path='/app/applications/mortgage/post-approvals/:id' component={MortgagePostApprovals} />
          <Route exact path='/app/applications/mortgage/post-returns/:id' component={MortgagePostReturn} />
          <Route exact path='/app/applications/mortgage/payment/:id' component={MortgagePayment} />
          {/* Mortgage Modification */}
          <Route
            exact
            path='/app/application/details/mortgage-modification/:id'
            component={MortgageModificationApplicationDetail}
          />
          <Route
            exact
            path='/app/application/mortgage-modification/post-returns/:id'
            component={MortgageModificationReturnFlow}
          />
          <Route
            exact
            path='/app/application/mortgage-modification/post-approvals/:id'
            component={MortgageModificationApprovalFlow}
          />
          <Route
            exact
            path='/app/applications/mortgage-modification/payment/:id'
            component={MortgageModificationPaymentFlow}
          />
          {/* transfer-offplan-to-complete routes */}
          <Route
            exact
            path='/app/application/detail/transfer-offplan/:id'
            component={TransferOffplanApplicationDetail}
          />
          <Route
            exact
            path='/app/applications/transfer-offplan/post-approvals/:id'
            component={TransferOffplanPostApprovals}
          />
          <Route
            exact
            path='/app/applications/transfer-offplan/post-returns/:id'
            component={TransferOffplanPostReturn}
          />
          <Route exact path='/app/applications/transfer-offplan/payment/:id' component={TransferOffplanPayment} />
          {/* NHL Mortgage */}
          <Route exact path='/app/application/detail/nhl-mortgage/:id' component={NhlMortgageApplicationDetail} />
          <Route exact path='/app/applications/nhl-mortgage/post-approvals/:id' component={NhlMortgagePostApprovals} />
          <Route exact path='/app/applications/nhl-mortgage/post-returns/:id' component={NhlMortgagePostReturn} />
          <Route exact path='/app/applications/nhl-mortgage/payment/:id' component={NhlMortgagePayment} />
          {/* Rent Payment */}
          <Route exact path='/app/application/detail/rent-payment/:id' component={RentPaymentApplicationDetails} />
          <Route exact path='/app/applications/rent-payment/owner-review/:id' component={RentPaymentApprovalFlow} />
          <Route exact path='/app/applications/rent-payment/owner-return/:id' component={RentPaymentReturnFlow} />
          <Route exact path='/app/applications/rent-payment/payment/:id' component={RentPaymentPaymentFlow} />
          {/* Off Plan Termination */}
          <Route
            exact
            path='/app/application/off-plan-termination/details/:id'
            component={OffPlanTerminationApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/off-plan-termination/post-approvals/:id'
            component={OffPlanTerminationApprovals}
          />
          <Route
            exact
            path='/app/applications/off-plan-termination/post-returns/:id'
            component={OffPlanTerminationReturn}
          />
          <Route
            exact
            path='/app/applications/off-plan-termination/bank-approval/:id'
            component={OffPlanTerminationBankFlow}
          />
          <Route
            exact
            path='/app/application/off-plan-termination/payment/:id'
            component={OffPlanTerminationPaymentFlow}
          />
          {/* Off Plan Termination */}
          <Route
            exact
            path='/app/application/detail/offplan-project-registration/:id'
            component={OffPlanProjectRegistrationApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/offplan-project-registration/post-approvals/:id'
            component={OffPlanProjectRegistrationApprovals}
          />
          <Route
            exact
            path='/app/applications/offplan-project-registration/post-returns/:id'
            component={OffPlanProjectRegistrationReturn}
          />
          <Route
            exact
            path='/app/applications/offplan-project-registration/payment/:id'
            component={OffPlanProjectRegistrationPayment}
          />
          {/* Projects */}
          <Route exact path='/app/projects-list' component={ProjectList} />
          {/* Developer project listing and detail */}
          <Route exact path='/app/projects-list' component={DeveloperProjectList} />
          <Route exact path='/app/projects-list/:id' component={DeveloperProjectDetail} />
          {/* DRC - Register Dispute */}
          <Route
            exact
            path='/app/application/detail/dispute-registration/:id'
            component={registerDisputeApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/dispute-registration/post-approvals/:id'
            component={registerDisputeApprovalsPage}
          />
          <Route
            exact
            path='/app/applications/dispute-registration/post-returns/:id'
            component={registerDisputeReturnedPage}
          />
          {/* DRC - Request for expert opinion */}
          <Route
            exact
            path='/app/applications/request-expert-opinion/post-approvals/:id'
            component={RequestForExpertOpinionApprovalsPage}
          />
          <Route
            exact
            path='/app/application/detail/request-expert-opinion/:id'
            component={RequestForExpertOpinionApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/request-expert-opinion/payment/:id'
            component={RequestForExpertOpinionPayment}
          />
          {/* DRC / Execution Stamp */}
          <Route exact path='/app/applications/execution-stamp/payment/:id' component={ExecutionStampPaymentFlow} />
          <Route
            exact
            path='/app/application/detail/execution-stamp/:id'
            component={ExecutionStampApplicationDetails}
          />
          {/* Profession Registration */}
          <Route
            exact
            path='/app/application/detail/profession-registration/:id'
            component={ProfessionRegistrationApplicationDetails}
          />
          <Route
            exact
            path='/app/application/detail/license-registration/:id' // there are multiple checks on the basis of license-registration so please make sure modify those accordingly
            component={ProfessionRegistrationApplicationDetails}
          />
          <Route
            exact
            path='/app/application/detail/license-registration/payment/:id' // there are multiple checks on the basis of license-registration so please make sure modify those accordingly
            component={ProfessionRegistrationPaymentFlow}
          />
          <Route
            exact
            path='/app/application/return/profession-registration/:id'
            component={ProfessionRegistrationReturnFlow}
          />
          {/* EScrow Account */}
          <Route
            exact
            path='/app/applications/escrow-account-registration/:id'
            component={EscrowAccountApplicationDetail}
          />
          <Route
            exact
            path='/app/applications/escrow-account-registration/review/:id'
            component={EscrowAccountApplicationDetailFinal}
          />
          <Route
            exact
            path='/app/applications/escrow-account-registration/payment/:id'
            component={EscrowAccountApplicationPayment}
          />
          {/* EScrow Account Service Provider Payment Approval */}
          <Route
            exact
            path='/app/applications/escrow-service-provider-payment-approval/review/:id'
            component={ServiceProviderApprovalApplicationDetailFinal}
          />
          <Route
            exact
            path='/app/applications/escrow-service-provider-payment-approval/:id'
            component={ServiceProviderApprovalApplicationDetail}
          />
          <Route
            exact
            path='/app/applications/escrow-service-provider-payment-approval/post-return/:id'
            component={ServiceProviderApprovalReturnApplicationDetail}
          />
          {/* Profession Registration */}
          <Route
            exact
            path='/app/application/detail/profession-registration/:id'
            component={ProfessionRegistrationApplicationDetails}
          />
          <Route
            exact
            path='/app/application/detail/broker-registration/:id' // there are multiple checks on the basis of broker-registration so please make sure modify those accordingly
            component={ProfessionRegistrationApplicationDetails}
          />
          <Route
            exact
            path='/app/application/return/profession-registration/:id'
            component={ProfessionRegistrationReturnFlow}
          />
          {/* offPlanBuySell */}
          <Route exact path='/app/applications/offplan-buy-sell/payment/:id' component={OffplanBuySellPayments} />
          <Route
            exact
            path='/app/application/detail/offplan-buy-sell/:id'
            component={OffPlanBuySellApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/offplan-buy-sell/post-approvals/:id'
            component={OffPlanBuySellApprovalFlow}
          />
          <Route
            exact
            path='/app/applications/offplan-buy-sell/post-returns/:id'
            component={OffPlanBuySellReturnFlow}
          />
          {/* Release Mortgage */}
          <Route
            exact
            path='/app/application/detail/mortgage-release/:id'
            component={MortgageReleaseApplicationDetails}
          />
          <Route
            exact
            path='/app/application/detail/mortgage-release/payment/:id'
            component={MortgageReleaseApplicationPayment}
          />
          <Route
            exact
            path='/app/application/mortgage-release/review/:id'
            component={MortgageReleaseApplicationApproval}
          />
          <Route
            exact
            path='/app/application/mortgage-release/return/:id'
            component={MortgageReleaseApplicationReturn}
          />
          {/* Offplan buy and sell */}
          <Route exact path='/app/applications/offplan-buy-sell/payment/:id' component={OffplanBuySellPayments} />
          <Route
            exact
            path='/app/application/detail/offplan-buy-sell/:id'
            component={OffPlanBuySellApplicationDetails}
          />
          <Route
            exact
            path='/app/applications/offplan-buy-sell/post-approvals/:id'
            component={OffPlanBuySellApprovalFlow}
          />
          <Route
            exact
            path='/app/applications/offplan-buy-sell/post-returns/:id'
            component={OffPlanBuySellReturnFlow}
          />
          {/* Permits */}
          <Route exact path='/app/application/detail/permit/:id' component={PermitsApplicationDetails} />
          {/* Valuation certificate */}
          <Route
            exact
            path='/app/application/detail/request-valuation-certificate-land/:id'
            component={ValuationCertificateApplicationDetails}
          />
          <Route
            exact
            path='/app/application/detail/valuation-certificate-unit/:id'
            component={ValuationCertificateApplicationDetails}
          />
          <Route
            exact
            path='/app/application/request-valuation-certificate-land/post-returns/:id'
            component={ValuationCertificateReturnFlow}
          />
          <Route
            exact
            path='/app/application/valuation-certificate-unit/post-returns/:id'
            component={ValuationCertificateReturnFlow}
          />
          {/* Power of Attornay */}
          <Route exact path='/app/application/details/register-poa/:id' component={RegisterPOAApplicationDetails} />
          <Route exact path='/app/application/details/terminate-poa/:id' component={TerminatePOAApplicationDetails} />
          <Route exact path='/app/applications/add-poa/post-return/:id' component={RegisterPOAApplicationReturn} />
          {/* Sell & Purchase */}
          <Route exact path='/app/application/detail/sell-purchase/:id' component={SellAndPurchaseApplicationDetails} />
          <Route
            exact
            path='/app/application/sell-purchase/post-approvals/:id'
            component={SellAndPurchaseApprovalFlow}
          />
          <Route exact path='/app/application/sell-purchase/post-returns/:id' component={SellAndPurchaseReturnFlow} />
          <Route exact path='/app/application/sell-purchase/payment/:id' component={SellAndPurchasePaymentFLow} />
          {/* Transfer Of Interest */}
          <Route
            exact
            path='/app/application/detail/transfer-of-interest/:id'
            component={TransferOfInterestApplicationDetails}
          />
          <Route
            exact
            path='/app/application/transfer-of-interest/post-approvals/:id'
            component={TransferOfInterestApprovalFlow}
          />
          <Route
            exact
            path='/app/application/transfer-of-interest/post-returns/:id'
            component={TransferOfInterestReturnFlow}
          />
          <Route
            exact
            path='/app/application/transfer-of-interest/payment/:id'
            component={TransferOfInterestPaymentFLow}
          />
          {/* Digital Transfer Of Interest */}
          <Route
            exact
            path='/app/application/detail/digital-transfer-of-interest/:id'
            component={DigitalTransferOfInterestApplicationDetails}
          />
          <Route
            exact
            path='/app/application/digital-transfer-of-interest/post-approvals/:id'
            component={DigitalTransferOfInterestApprovalFlow}
          />
          <Route
            exact
            path='/app/application/digital-transfer-of-interest/post-returns/:id'
            component={DigitalTransferOfInterestReturnFlow}
          />
          <Route
            exact
            path='/app/application/digital-transfer-of-interest/payment/:id'
            component={DigitalTransferOfInterestPaymentFLow}
          />
          {/* Mustaha Contract */}
          <Route
            exact
            path='/app/application/interpersonal-musataha-contract/post-approvals/:id'
            component={MusatahaContractRegistrationApprovalFlow}
          />
          <Route
            exact
            path='/app/application/detail/interpersonal-musataha-contract/:id'
            component={MusatahaContractRegistrationAppDetail}
          />
          <Route
            exact
            path='/app/application/interpersonal-musataha-contract/payment/:id'
            component={MusatahaContractPayemnt}
          />
          <Route
            exact
            path='/app/application/interpersonal-musataha-contract/return/:id'
            component={MusatahaContractRegReturn}
          />
          <Route
            exact
            path='/app/application/details/profile-creation/:id'
            component={ManualProfileCreationApplicationDetails}
          />
          <Route
            exact
            path='/app/application/profile-creation/post-returns/:id'
            component={ManualProfileCreationReturnFlow}
          />
          <Route
            exact
            path='/app/application/details/instant-service/:id'
            component={InstantServiceApplicationDetails}
          />
          {/* Madhmoun */}
          <Route
            exact
            path='/app/application/details/request-permit-advertisement/:id'
            component={RequestPermitAdvertisementDetails}
          />
          <Route
            exact
            path='/app/applications/request-permit-advertisement/payment/:id'
            component={RequestPermitAdvertisementPayment}
          />
          <Route
            exact
            path='/app/application/request-permit-advertisement/post-returns/:id'
            component={RequestPermitAdvertisementReturnFlow}
          />
          <Route
            exact
            path='/app/application/request-permit-advertisement/post-approvals/:id'
            component={RequestPermitAdvertisementApprovalFlow}
          />
          {/* End - Madhmoun */}
          <Route exact path='/app/application/instant-service/payment/:id' component={InstantServicePaymentFlow} />
          <Route exact path='/app/application/details/certificates/:id' component={CertificatesApplicationDetails} />
          <Route exact path='/app/application/certificates/payment/:id' component={CertificatesPaymentFlow} />
          <Route exact path='/app/application/details/legal-notice/:id' component={LegalNoticeApplicationDetails} />
          <Route exact path='/app/application/legal-notice/post-returns/:id' component={LegalNoticeReturnFlow} />
          <Route exact path='/app/application/legal-notice/post-approvals/:id' component={LegalNoticeApprovalFlow} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </Dashboard>
  );
}
Application.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default Application;
